import { render } from "./GullsComponent.vue?vue&type=template&id=2d79d176&scoped=true"
import script from "./GullsComponent.vue?vue&type=script&lang=js"
export * from "./GullsComponent.vue?vue&type=script&lang=js"

import "./GullsComponent.vue?vue&type=style&index=0&id=2d79d176&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d79d176"]])

export default __exports__